module.exports = __webpack_public_path__ + "4aedf716b532e9cf360a728253ac0bc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/project-documentations/static/k-app-feature-image.png
// module id = 258
// module chunks = 0